import script from "./SidebarComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarComponent.vue?vue&type=script&setup=true&lang=ts"

import "./SidebarComponent.vue?vue&type=style&index=0&id=59da8ff4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59da8ff4"]])

export default __exports__